export const sortTypes = Object.freeze({
  EMAIL: "email",
  FULL_NAME: "full_name",
  DATE: "date",
  TIME_TAKEN: "time_taken",
  SCORE: "score"
});
